// The hero Tizmo. A tiny state machine: seven screens, autoplay unless touched,
// a time-lapse timer on the dark screen, and a loop back to the start.
const root = document.querySelector("[data-demo]")
if (root) {
  const phone = root.querySelector("[data-demo-phone]")
  const screens = [...root.querySelectorAll("[data-screen]")]
  const dots = [...root.querySelectorAll(".demo-dots i")]
  const caption = root.querySelector("[data-caption]")
  const timerEl = root.querySelector("[data-timer]")
  const awayTotal = root.querySelector("[data-away-total]")
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  const CAPTIONS = [
    "Screen one: the teacher’s hello. Tap to play it through.",
    "Before they go: a guess, not a quiz.",
    "The mission — with a built-in way to know it’s done.",
    "The screen goes dark. The timer counts time away from it.",
    "Back: done, a photo, one line.",
    "Think back: a question only a kid who did it can answer.",
    "Done. Screen time used, honestly.",
  ]
  const HOLD = [3200, 2600, 4200, 4200, 3600, 3400, 5200]

  let i = 0
  let timer = null
  let tick = null
  let paused = false
  let pauseUntil = 0
  let awaySeconds = 0
  let inView = false

  const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`

  function show(n) {
    i = (n + screens.length) % screens.length
    screens.forEach((s, k) => s.classList.toggle("is-active", k === i))
    dots.forEach((d, k) => d.classList.toggle("is-on", k <= i))
    phone.classList.toggle("is-night", screens[i].dataset.screen === "away")
    if (caption) caption.textContent = CAPTIONS[i]
    // the real-world accents beside the phone follow the screen
    const name = screens[i].dataset.screen
    document.querySelectorAll("[data-stage-for]").forEach((el) => el.classList.toggle("is-on", el.dataset.stageFor === name))
    clearInterval(tick)
    if (screens[i].dataset.screen === "away") {
      awaySeconds = 0
      timerEl.textContent = fmt(0)
      // time-lapse: a real mission takes ten minutes; here it takes four seconds
      tick = setInterval(() => {
        awaySeconds += 9 + Math.floor(Math.random() * 6)
        timerEl.textContent = fmt(awaySeconds)
      }, 90)
    }
    if (screens[i].dataset.screen === "done" && awaySeconds) awayTotal.textContent = fmt(Math.max(awaySeconds, 60))
    if (screens[i].dataset.screen === "report") typeLine()
    schedule()
  }

  function schedule() {
    clearTimeout(timer)
    if (reduced || !inView) return
    const wait = Math.max(HOLD[i], pauseUntil - Date.now())
    timer = setTimeout(() => show(i + 1), wait)
  }

  function touched() {
    // a person is driving: hold off autoplay for a while
    pauseUntil = Date.now() + 9000
    schedule()
  }

  function typeLine() {
    const el = root.querySelector("[data-typed-line]")
    if (!el) return
    const text = "One thing I noticed: the ball rolls fastest."
    el.textContent = ""
    if (reduced) {
      el.textContent = text
      return
    }
    let k = 0
    const t = setInterval(() => {
      el.textContent = text.slice(0, ++k)
      if (k >= text.length) clearInterval(t)
    }, 28)
  }

  // taps
  root.querySelectorAll("[data-next]").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.stopPropagation()
      touched()
      show(i + 1)
    })
  )
  root.querySelector("[data-restart]")?.addEventListener("click", (e) => {
    e.stopPropagation()
    touched()
    resetBits()
    show(0)
  })
  root.querySelectorAll("[data-choice]").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.stopPropagation()
      touched()
      root.querySelectorAll("[data-choice]").forEach((c) => c.classList.remove("is-on"))
      b.classList.add("is-on")
      root.querySelector("[data-feedback]")?.classList.add("is-on")
    })
  )
  root.querySelector("[data-tick]")?.addEventListener("click", (e) => {
    e.stopPropagation()
    touched()
    e.currentTarget.classList.toggle("is-on")
  })
  root.querySelector("[data-photo]")?.addEventListener("click", (e) => {
    e.stopPropagation()
    touched()
    e.currentTarget.classList.add("is-on")
    root.querySelector("[data-photo-label]").textContent = "Photo added — three_round_things.jpg"
  })
  // tapping anywhere else on the phone also advances
  phone.addEventListener("click", () => {
    touched()
    show(i + 1)
  })
  phone.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight" || e.key === " " || e.key === "Enter") {
      e.preventDefault()
      touched()
      show(i + 1)
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault()
      touched()
      show(i - 1)
    }
  })

  function resetBits() {
    root.querySelectorAll(".is-on").forEach((el) => el.classList.remove("is-on"))
    const label = root.querySelector("[data-photo-label]")
    if (label) label.textContent = "Add a photo"
  }

  // autoplay while on screen; the predicted choice and the ticks pick themselves when nobody does
  const auto = () => {
    if (Date.now() < pauseUntil) return
    const s = screens[i].dataset.screen
    if (s === "predict") {
      root.querySelectorAll("[data-choice]")[0].classList.add("is-on")
      root.querySelector("[data-feedback]")?.classList.add("is-on")
    }
    if (s === "report") {
      setTimeout(() => Date.now() >= pauseUntil && root.querySelector("[data-tick]")?.classList.add("is-on"), 700)
      setTimeout(() => {
        if (Date.now() < pauseUntil) return
        root.querySelector("[data-photo]")?.classList.add("is-on")
        root.querySelector("[data-photo-label]").textContent = "Photo added — three_round_things.jpg"
      }, 1500)
    }
    if (s === "hello") resetBits()
  }
  const origShow = show
  show = function (n) {
    origShow(n)
    auto()
  }

  const io = new IntersectionObserver(
    (entries) => {
      inView = entries.some((e) => e.isIntersecting)
      if (inView) schedule()
      else clearTimeout(timer)
    },
    { threshold: 0.35 }
  )
  io.observe(phone)
  dots[0]?.classList.add("is-on")
  if (caption) caption.textContent = CAPTIONS[0]
  auto()
}
